import React from 'react'
import dynamic from 'next/dynamic'
import { Insight, InsightComponentProps } from 'src/components/insights/types'
import { ImageSearch } from '@emotion-icons/material-outlined/ImageSearch'
import { FullScreenLoading } from 'src/components/full-screen-loading'
import { Colors } from 'src/components/theme'
import { InsightContainer } from 'src/v2/views/owner-reveal/insights/container'

const DynamicContent = dynamic(() => import('src/components/insights/place-debug/content'), {
  loading: () => <FullScreenLoading />,
  ssr: false,
})

const DebugPage: React.FC<InsightComponentProps> = (props) => {
  const { insight } = props

  return (
    <InsightContainer insight={insight} color={Colors.purpleDark} downloadable={false}>
      <React.Suspense fallback={<FullScreenLoading />}>
        <DynamicContent />
      </React.Suspense>
    </InsightContainer>
  )
}

export const PlaceDebug: Insight = {
  id: 'place-debug',
  component: DebugPage,
  name: 'Place Debug',
  icon: ImageSearch,
  supportedResultTypes: ['venue', 'alphamap-location', 'address'],
  linkTooltipFile: '',
}
